/* eslint-disable no-unused-expressions */
import { getUserId } from '@banksalad/js-banksalad';
import * as Sentry from '@sentry/browser';

import { getAllCookieAppInfo } from '@/utils/app-info';
import { CONFIG } from '@/utils/sentry/config';

const initSentry = async () => {
  Sentry.init(CONFIG.SENTRY);

  setSentryAppInfo();
  await setSentryUser();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const sentryErrorHandler = (func?: (error: any) => void) => (error: any) => {
  Sentry.setExtra('errorLog', error);
  Sentry.captureException(error);

  func && func(error);
};

const setSentryUser = async () => {
  try {
    const userId = await getUserId();

    if (!userId) {
      return;
    }

    Sentry.setUser({ id: userId });
  } catch (error) {
    console.warn('[sentry] failed to set user context', error);
    Sentry.captureException(error as Error);
  }
};

const setSentryAppInfo = () => {
  const cookieAppInfo = getSafeCookieAppInfo();
  const appInfo = {
    applicationVersion: cookieAppInfo?.applicationVersion,
    buildType: cookieAppInfo?.buildType,
    deviceId: cookieAppInfo?.deviceId,
    releaseType: cookieAppInfo?.releaseType,
    sessionId: cookieAppInfo?.sessionId,
  };

  const hasAppInfo = Object.values(appInfo).some(Boolean);

  if (!hasAppInfo) {
    return;
  }

  Sentry.setContext('appInfo', appInfo);
  Sentry.setTags({
    'appInfo-applicationVersion': appInfo.applicationVersion ?? '',
    'appInfo-buildType': appInfo.buildType ?? '',
    'appInfo-deviceId': appInfo.deviceId ?? '',
    'appInfo-releaseType': appInfo.releaseType ?? '',
    'appInfo-sessionId': appInfo.sessionId ?? '',
  });
};

const getSafeCookieAppInfo = () => {
  try {
    return getAllCookieAppInfo();
  } catch (error) {
    console.warn('[sentry] failed to read app info from cookie', error);
    Sentry.captureException(error as Error);

    return undefined;
  }
};

export { initSentry, sentryErrorHandler };
